import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useStoreInfo() {
  const [info, setInfo] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/store/info").then((r) => { cache = r.data; setInfo(r.data); }).catch(() => {});
  }, []);
  return info;
}
